import axios from "axios"

var baseURL = process.env.VUE_APP_ROOT_API;

if (window.location.toString().indexOf("://localhost") > -1 || window.location.toString().indexOf(".local") > -1)
{
	baseURL = process.env.VUE_APP_ROOT_API_LOCAL
}
else if (window.location.toString().indexOf("://192.168.1") > -1)
{
	baseURL = process.env.VUE_APP_ROOT_API_DEV
}
else if (window.location.toString().indexOf("egello.com") > -1)
{
	baseURL = process.env.VUE_APP_ROOT_API_TEST
}

export default axios.create(
	{
		baseURL: baseURL,
		withCredentials: false,
		headers: {
			Accept: "application/json",
			"Content-Type": "application/json"
		}
	})